import { render, staticRenderFns } from "./PaymentSimulate.vue?vue&type=template&id=c65336da"
import script from "./PaymentSimulate.vue?vue&type=script&lang=js"
export * from "./PaymentSimulate.vue?vue&type=script&lang=js"
import style0 from "./PaymentSimulate.vue?vue&type=style&index=0&id=c65336da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports